import { render, staticRenderFns } from "./SportProgramAddFaq.vue?vue&type=template&id=2611c0f5&"
import script from "./SportProgramAddFaq.vue?vue&type=script&lang=js&"
export * from "./SportProgramAddFaq.vue?vue&type=script&lang=js&"
import style0 from "./SportProgramAddFaq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports